import { render, staticRenderFns } from "./EffectivenessRibbonFeedback.vue?vue&type=template&id=e2a756b8&"
import script from "./EffectivenessRibbonFeedback.vue?vue&type=script&lang=js&"
export * from "./EffectivenessRibbonFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports